import React from 'react'
import { CheckCircle2 } from 'lucide-react'
import { FLASH_TOAST_EVENT } from '@/lib/flashToast'

const SHOW_MS = 6000

/** Shows what `showFlashToast` sends, at the bottom of the screen, for a few seconds. Mounted once. */
export function FlashToastHost() {
  const [message, setMessage] = React.useState('')
  React.useEffect(() => {
    let timer: number | undefined
    const onFlash = (event: Event) => {
      const text = (event as CustomEvent<string>).detail
      if (!text) return
      setMessage(text)
      window.clearTimeout(timer)
      timer = window.setTimeout(() => setMessage(''), SHOW_MS)
    }
    window.addEventListener(FLASH_TOAST_EVENT, onFlash)
    return () => {
      window.removeEventListener(FLASH_TOAST_EVENT, onFlash)
      window.clearTimeout(timer)
    }
  }, [])
  if (!message) return null
  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="flash-toast"
      className="fixed bottom-20 left-1/2 z-[60] flex w-[calc(100%-2rem)] max-w-md -translate-x-1/2 items-start gap-2 rounded-lg theme-light bg-gray-900 px-4 py-3 text-sm text-white shadow-lg lg:bottom-6"
    >
      <CheckCircle2 className="mt-0.5 h-4 w-4 flex-shrink-0 text-green-400" aria-hidden="true" />
      <span className="min-w-0 flex-1">{message}</span>
    </div>
  )
}
